import { PaypalButton } from '../PaypalButton/PaypalButton';
import { connectPayPalButton } from './connectPaypalButton';

export const PaypalCheckoutButton = connectPayPalButton(PaypalButton);
